<button
     class="btn btn-primary psp-scroll-to-top-btn"
     (click)="scrollToTop()"
     type="button"
     aria-label="Scroll to top"
     title="Scroll to top"
>
     <i class="fa fa-chevron-up px-2"></i> 
</button>